import { config as appConfig } from "/app.config"
import { PODCAST_CATEGORIES } from "@/common/constants/podcastCategories"

export const podcasts = (state) => state.podcasts

export const podcast = (state) => state.podcast

export const podcastCategories = () => PODCAST_CATEGORIES

export const podcastRSSLink = (state) => {
  if (!state.podcast.key) {
    return ""
  }

  return appConfig.podcastFeedURL + state.podcast.key + "/rss"
}
